import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store/store';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
    mode: 'history',
    routes, // short for routes: routes
    linkActiveClass: 'active',
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    let sesion = (localStorage.getItem('es-login') !== null) ? JSON.parse(localStorage.getItem('es-login')) : { _id: null, status: null, token: null, role: null };
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let roles = (to.meta.roles) ? to.meta.roles : [];
        if (!sesion.status) {
            next('/')
        } else {
            if (roles.indexOf(sesion.role) > -1) {
                next()
            } else {
                next('/404')
            }
        }
    } else {
        if (to.path === "/" && from.path === "/reservations") {
            if (!sesion.status) {
                next();
            } else {
                next(false);
            }
        } else {
            next()
        }
    }
})

export default router;